import { render, staticRenderFns } from "./SuggestOffers.vue?vue&type=template&id=68f31084"
import script from "./SuggestOffers.vue?vue&type=script&lang=js"
export * from "./SuggestOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports